import React from 'react';
import { Quote, Star } from 'lucide-react';
import { TESTIMONIALS } from '../mock';

export default function Testimonials() {
  return (
    <section className="py-20 lg:py-28 bg-black text-white relative overflow-hidden">
      <div className="absolute -top-32 -right-24 w-[420px] h-[420px] rounded-full bg-[#e11d2c]/20 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 -left-24 w-[420px] h-[420px] rounded-full bg-[#e11d2c]/10 blur-3xl pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="inline-flex items-center gap-2 bg-white/10 px-3.5 py-1.5 rounded-full text-[11px] tracking-[0.18em] uppercase font-semibold">
            Real Stories
          </div>
          <h2 className="font-display mt-5 text-[36px] sm:text-[48px] lg:text-[56px] font-black leading-[1.02] tracking-tight">
            Words from our <span className="text-[#e11d2c]">drivers</span>.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <div key={t.id} className={`bg-white/[0.06] backdrop-blur border border-white/10 rounded-2xl p-6 hover:border-[#e11d2c]/60 transition-all hover:-translate-y-1 ${i === 1 ? 'md:translate-y-6' : ''}`}>
              <Quote className="text-[#e11d2c]" size={22} />
              <p className="mt-4 text-[14px] leading-relaxed text-white/85">“{t.text}”</p>
              <div className="mt-5 flex items-center gap-3 pt-5 border-t border-white/10">
                <div className="w-10 h-10 grid place-items-center rounded-full bg-[#e11d2c] text-white font-bold text-[13px]">{t.initials}</div>
                <div className="flex-1 min-w-0">
                  <div className="font-semibold text-[14px] truncate">{t.name}</div>
                  <div className="text-[11px] text-white/60 truncate">{t.role}</div>
                </div>
                <div className="flex items-center gap-0.5 text-[#e11d2c]">
                  {Array.from({length: t.rating}).map((_, k) => <Star key={k} size={12} className="fill-[#e11d2c]" />)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
